module.exports = __webpack_public_path__ + "static/media/deliverytruck.76b169fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/deliverytruck.svg
// module id = 644
// module chunks = 0